"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentSectionModel = exports.ContentModel = exports.CONTENT_SECTIONS = void 0;
var class_validator_1 = require("class-validator");
exports.CONTENT_SECTIONS = [
    "wysiwyg",
    "image",
    "youtube",
    "dreambroker",
    "link",
    "audio",
    "gif"
];
var ContentModel = /** @class */ (function () {
    function ContentModel() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsInt(),
        class_validator_1.Min(0),
        class_validator_1.Max(2147483647),
        __metadata("design:type", Object)
    ], ContentModel.prototype, "sortOrder", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], ContentModel.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], ContentModel.prototype, "title", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], ContentModel.prototype, "active", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], ContentModel.prototype, "imageId", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Object)
    ], ContentModel.prototype, "image", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Array)
    ], ContentModel.prototype, "categories", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Array)
    ], ContentModel.prototype, "subCategories", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Array)
    ], ContentModel.prototype, "sections", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], ContentModel.prototype, "help", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], ContentModel.prototype, "likes", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], ContentModel.prototype, "dislikes", void 0);
    return ContentModel;
}());
exports.ContentModel = ContentModel;
var ContentSectionModel = /** @class */ (function () {
    function ContentSectionModel() {
    }
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], ContentSectionModel.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        __metadata("design:type", Number)
    ], ContentSectionModel.prototype, "contentId", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], ContentSectionModel.prototype, "content", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], ContentSectionModel.prototype, "imageId", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Object)
    ], ContentSectionModel.prototype, "image", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Object)
    ], ContentSectionModel.prototype, "gif", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], ContentSectionModel.prototype, "gifId", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Object)
    ], ContentSectionModel.prototype, "audio", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], ContentSectionModel.prototype, "audioId", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        __metadata("design:type", Number)
    ], ContentSectionModel.prototype, "position", void 0);
    __decorate([
        class_validator_1.IsIn(exports.CONTENT_SECTIONS),
        __metadata("design:type", String)
    ], ContentSectionModel.prototype, "type", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], ContentSectionModel.prototype, "linkText", void 0);
    return ContentSectionModel;
}());
exports.ContentSectionModel = ContentSectionModel;
//# sourceMappingURL=ContentModel.js.map